import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { applyConsent, trackPageView } from "@/lib/analytics";

/* Loads consent-gated pixels and tracks SPA page views.
 * Renders nothing. Must live inside the Router + SettingsProvider. */
export const Analytics = () => {
  const { settings, effectiveConsent, loading } = useSettings();
  const location = useLocation();
  const initialized = useRef(false);

  // Load / refresh providers whenever settings or consent changes.
  useEffect(() => {
    if (loading) return;
    applyConsent(settings, effectiveConsent);
  }, [settings, effectiveConsent, loading]);

  // Track page views on route change (no-op until a provider is loaded).
  useEffect(() => {
    // Skip the very first run only if a provider was not yet loaded; otherwise track.
    const path = location.pathname + location.search;
    if (!initialized.current) {
      initialized.current = true;
    }
    trackPageView(path);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
